var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('StatusLamp'),_c('span',{staticClass:"version-name",class:_vm.isBold},[_vm._v("\n      "+_vm._s(_vm.versionLabel)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }